export default __webpack_public_path__ + "static/media/back.ffc9e952.svg";